import EditPageContainer from '@app/components/EditPageContainer'
import { bindFunctions } from '@app/utils/class'
import * as qs from 'query-string'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { RouteComponentProps } from 'react-router-dom'
import { Alert, Container } from 'reactstrap'
import { IListingPageEditState } from '../modules/listingEdit'
import { actionCreators } from '@app/components/ListingEdit/modules/listingEdit'
import ListingEdit from '@app/components/ListingEdit'
import { Listing } from '@app/models/Listing'

type ListingEditProps = IListingPageEditState &
  typeof actionCreators &
  RouteComponentProps<{ id?: string }>

export default class ListingEditPage extends React.PureComponent<
  ListingEditProps
> {
  constructor(props: ListingEditProps) {
    super(props)

    bindFunctions(this)
  }

  public componentWillUnmount() {
    this.props.resetState()
  }

  public render() {
    const query = qs.parse(this.props.location.search)

    return (
      <EditPageContainer
        saveDisabled={false}
        title={
          this.props.match.params.id
            ? `${this.props.listing.title} :: Edit`
            : 'New Listing'
        }
        onSaveClick={this._onSave}
        onCancelClick={this._onCancel}
      >
        <ListingEdit
          listingId={this.props.match?.params?.id}
          propertyId={query.property}
          spaceId={query.space}
          lotId={query.lot}
          siteId={query.site}
        />
      </EditPageContainer>
    )
  }

  private _onCancel() {
    this.props.history.goBack()
  }

  private _onSave() {
    this.props.saveListing(this.props.listing as Listing)
  }
}
